<template>
  <cf-loading-wrapper
    :is-loading="isLoading"
    :loader-type="'page'"
  >
    <cf-scan-to-pay />
  </cf-loading-wrapper>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import CfScanToPay from './cf-scan-to-pay/index.vue';

  import CfLoadingWrapper from '@/view/components/globals/cf-loading-wrapper/index.vue';


  export default {
    name: 'ScanToPayPage',

    components: {
      CfScanToPay,
      CfLoadingWrapper
    },

    metaInfo() {
      return {
        title: 'Credit Cards'
      };
    },

    data() {
      return {
        isLoading: false
      };
    },

    computed: {
      ...mapGetters('offers', ['loyalty', 'offers']),
      ...mapGetters('session', ['currentUser']),
      ...mapGetters('locations', ['timeZone']),

      ...mapGetters('savedCards', ['savedCards']),
      ...mapGetters('giftCards', ['giftCards']),

      paymentMethods() {
        return [
          ...this.giftCards.savedCards,
          ...this.savedCards.cards
        ];
      },

      hasAppliedOffer() {
        return Object.keys(this.appliedOffer).length > 0;
      },

      hasOffers() {
        return !!this.offers.allOffers.length;
      },

      numberOfDots() {
        /** Need to add 1 to account for final "add method" card */
        return this.paymentMethods.length + 1;
      },

      isScrolledToAddPaymentMethodCard() {
        return this.focusedCard === this.paymentMethods.length;
      }
    },

    async created() {
      await this.createdHandler();
    },

    methods: {
      async createdHandler() {
        this.isLoading = true;

        try {
          await this.$store.dispatch('savedCards/getCards');

          await this.$store.dispatch('giftCards/getSavedCards');

          await this.$store.dispatch('offers/getOffers', {
            silent: true
          });
        }
        catch (error) {
          errorHandlers.generic(error);
        }
        finally {
          this.isLoading = false;
        }
      }
    }
  };
</script>
